import { Outlet } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import i18n, { I18nextProvider } from "@/lib/i18n";
import { LocaleProvider } from "@/lib/locale/locale-provider";
import theme from "@/theme/index";
import { ConfirmDialogManager, ToastManager } from "@/features/shared/components";
import PreviewMode from "@/features/shared/components/preview-mode/preview-mode";
import { useIsAdminRoute } from "@/features/shared/navigation";

const AppShell = () => {
  const isAdminRoute = useIsAdminRoute();

  return (
    <I18nextProvider i18n={i18n}>
      <LocaleProvider>
        <MuiThemeProvider theme={theme}>
          <CssBaseline />
          <ThemeProvider
            defaultTheme="system"
            forcedTheme={isAdminRoute ? "light" : undefined}
          >
            <PreviewMode />
            <ToastManager />
            <ConfirmDialogManager />
            <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
            <Outlet />
          </ThemeProvider>
        </MuiThemeProvider>
      </LocaleProvider>
    </I18nextProvider>
  );
};

export default AppShell;
